import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.gSiteName === 'xoilaczxc')
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("g", { "clip-path": "url(#clip0_15_4710)" }, [
          _createElementVNode("path", {
            d: "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM13.3333 14.5L9.16667 10.3333V3.33333H10.8333V9.66667L14.5 13.3333L13.3333 14.5Z",
            fill: "#7E8793"
          })
        ], -1),
        _createElementVNode("defs", null, [
          _createElementVNode("clipPath", { id: "clip0_15_4710" }, [
            _createElementVNode("rect", {
              width: "20",
              height: "20",
              fill: "white"
            })
          ])
        ], -1)
      ])))
    : (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[1] || (_cache[1] = [
        _createStaticVNode("<rect x=\"2\" y=\"4\" width=\"8\" height=\"2.6\" fill=\"#9C9C9C\"></rect><rect x=\"5\" y=\"9.2002\" width=\"5\" height=\"2.6\" fill=\"#9C9C9C\"></rect><rect x=\"4\" y=\"14.4004\" width=\"6\" height=\"2.6\" fill=\"#9C9C9C\"></rect><rect x=\"11\" y=\"4\" width=\"5\" height=\"2.6\" fill=\"#9C9C9C\"></rect><rect x=\"11\" y=\"9.2002\" width=\"3\" height=\"2.6\" fill=\"#9C9C9C\"></rect><rect x=\"11\" y=\"14.4004\" width=\"8\" height=\"2.6\" fill=\"#9C9C9C\"></rect>", 6)
      ])))
}